import React, { Component } from 'react';
import FormCreate from './FormCreate';
import FormCreateCondition from './FormCreateCondition';
import Swal from "sweetalert2/dist/sweetalert2.js";

class Index extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
            showForm: false,
            modeEdit: false,
            editSearch: null,
            conditionCreateForId: "",
            conditionEditId: "",
        };
    }

    componentDidMount = () => {
        this.loadData();
    }

    messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    loadData = () => {
        // Si el modal se abrio desde una pregunta especifica, filtramos por ella.
        // El backend devuelve solo buscadores donde esa pregunta es target de algun mapping
        // (mismo criterio que v1, que se configura desde la pregunta target).
        const questionId = this.props.question && this.props.question.id;
        const url = questionId
            ? `/formatos/get_format_search_v2s/${this.props.format.id}?question_id=${questionId}`
            : `/formatos/get_format_search_v2s/${this.props.format.id}`;
        fetch(url, {
            method: 'GET',
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ data: data.data, isLoaded: false });
            });
    }

    handleCreated = (register) => {
        // Si ya existe (actualizacion en edicion dentro del form), reemplazar
        if (this.state.data.find(d => d.id === register.id)) {
            this.setState({ data: this.state.data.map(d => d.id === register.id ? register : d) });
        } else {
            this.setState({ data: [...this.state.data, register] });
        }
    }

    handleUpdated = (register) => {
        this.setState({ data: this.state.data.map(d => d.id === register.id ? register : d) });
    }

    handleEdit = (search) => {
        this.setState({ showForm: true, modeEdit: true, editSearch: search });
    }

    handleDelete = (id) => {
        Swal.fire({
            title: "Eliminar buscador?",
            text: "El registro sera eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/formatos/format_search_v2s/${id}`, {
                    method: 'DELETE',
                    headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
                })
                    .then(r => r.json())
                    .then(response => {
                        this.setState({ data: this.state.data.filter(item => item.id !== id) });
                        this.messageSuccess(response);
                    });
            }
        });
    }

    handleConditionCreated = (searchId, register) => {
        this.setState({
            conditionCreateForId: "",
            data: this.state.data.map(d => {
                if (d.id === searchId) {
                    return { ...d, format_search_v2_conditions: [...(d.format_search_v2_conditions || []), register] };
                }
                return d;
            })
        });
    }

    handleConditionUpdated = (searchId, register) => {
        this.setState({
            conditionEditId: "",
            data: this.state.data.map(d => {
                if (d.id === searchId) {
                    return {
                        ...d,
                        format_search_v2_conditions: (d.format_search_v2_conditions || []).map(c =>
                            c.id === register.id ? register : c
                        )
                    };
                }
                return d;
            })
        });
    }

    deleteCondition = (searchId, conditionId) => {
        Swal.fire({ title: "Eliminar condicion?", type: "warning", showCancelButton: true, confirmButtonText: "Si", cancelButtonText: "Cancelar" }).then(result => {
            if (result.value) {
                fetch(`/formatos/format_search_v2_conditions/${conditionId}`, {
                    method: 'DELETE',
                    headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
                })
                    .then(r => r.json())
                    .then(data => {
                        Swal.fire({ position: "center", type: data.type, title: data.success, showConfirmButton: false, timer: 1500 });
                        this.setState({
                            data: this.state.data.map(d => {
                                if (d.id === searchId) {
                                    return { ...d, format_search_v2_conditions: (d.format_search_v2_conditions || []).filter(c => c.id !== conditionId) };
                                }
                                return d;
                            })
                        });
                    });
            }
        });
    }

    render() {
        const styeleIcons = { fontSize: "16px", color: "#3f69d8", cursor: "pointer" };

        return (
            <div>
                {this.state.showForm && !this.state.modeEdit && (
                    <FormCreate
                        key="new"
                        format={this.props.format}
                        formatos={this.props.formatos}
                        modeEdit={false}
                        search={null}
                        onCreated={this.handleCreated}
                        onUpdated={this.handleUpdated}
                        onClose={() => this.setState({ showForm: false, modeEdit: false, editSearch: null })}
                    />
                )}

                <div className="col-md-12 mb-3 text-right pr-0">
                    {!this.state.showForm && (
                        <button
                            className="btn-shadow btn btn-info"
                            onClick={() => this.setState({ showForm: true, modeEdit: false, editSearch: null })}
                        >
                            <i className="fas fa-plus mr-1" /> Nuevo buscador
                        </button>
                    )}
                </div>

                {this.state.data.length >= 1 ? (
                    this.state.data.map((search) => (
                        <div className="card mb-3" key={search.id}>
                            {this.state.modeEdit && this.state.editSearch && this.state.editSearch.id === search.id ? (
                                <div style={{ padding: '12px 16px' }}>
                                    <FormCreate
                                        key={`edit-${search.id}`}
                                        format={this.props.format}
                                        formatos={this.props.formatos}
                                        modeEdit={true}
                                        search={search}
                                        onCreated={this.handleCreated}
                                        onUpdated={this.handleUpdated}
                                        onClose={() => this.setState({ showForm: false, modeEdit: false, editSearch: null })}
                                    />
                                </div>
                            ) : (
                                <React.Fragment>
                                    <div style={{ display: "block", padding: '12px 16px', borderBottom: '1px solid #e5e7eb' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                            <span style={{ fontWeight: 600, fontSize: 14 }}>
                                                Buscador {search.match_mode === 'aggregate' ? '(avanzado)' : '(simple)'}
                                            </span>
                                            <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                                                <button className="btn btn-sm" onClick={() => this.handleEdit(search)}>
                                                    <i className="fas fa-pencil-alt" style={styeleIcons} />
                                                </button>
                                                <button className="btn btn-sm" onClick={() => this.handleDelete(search.id)}>
                                                    <i className="fas fa-trash-alt" style={styeleIcons} />
                                                </button>
                                            </div>
                                        </div>

                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 24px' }}>
                                            <div>
                                                <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Formato fuente</span>
                                                <span style={{ fontSize: 13, fontWeight: 500 }}>{search.format_source_info ? search.format_source_info.name : '-'}</span>
                                            </div>
                                            <div>
                                                <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Pregunta disparadora</span>
                                                <span style={{ fontSize: 13, fontWeight: 500 }}>{search.question_compare_info ? search.question_compare_info.name : '-'}</span>
                                            </div>
                                            <div>
                                                <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Pregunta a comparar (fuente)</span>
                                                <span style={{ fontSize: 13, fontWeight: 500 }}>{search.question_compare_source_info ? search.question_compare_source_info.name : '-'}</span>
                                            </div>
                                            <div>
                                                <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Mapeos configurados</span>
                                                <span style={{ fontSize: 13, fontWeight: 500 }}>{(search.format_search_v2_mappings || []).length}</span>
                                            </div>
                                        </div>

                                        {(search.format_search_v2_mappings || []).length > 0 && (
                                            <div style={{ marginTop: 8, padding: '6px 10px', background: '#f0f7ff', borderRadius: 4, fontSize: 12 }}>
                                                {search.format_search_v2_mappings.map((m, i) => (
                                                    <div key={m.id}>
                                                        <span style={{ fontWeight: 500 }}>{m.question_target_info && m.question_target_info.name}</span>
                                                        <span style={{ color: '#999', margin: '0 6px' }}>←</span>
                                                        <span style={{ color: '#3498db', fontWeight: 500 }}>{m.question_source_info && m.question_source_info.name}</span>
                                                        {m.operation && (
                                                            <span style={{ color: '#e67e22', marginLeft: 6 }}>({m.operation})</span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    <div style={{ padding: '8px 16px', background: '#f9fafb' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                            <span style={{ fontSize: 12, fontWeight: 600, color: '#666' }}>
                                                Condiciones ({(search.format_search_v2_conditions || []).length})
                                            </span>
                                            <div>
                                                {this.state.conditionCreateForId === search.id && (
                                                    <FormCreateCondition
                                                        isOpen={true}
                                                        target={`PopoverCreateSV2Condition${search.id}`}
                                                        format_search_v2={search}
                                                        modeEdit={false}
                                                        existingConditionsCount={(search.format_search_v2_conditions || []).length}
                                                        onCreated={(register) => this.handleConditionCreated(search.id, register)}
                                                        onClose={() => this.setState({ conditionCreateForId: "" })}
                                                    />
                                                )}
                                                <button
                                                    className="btn btn-info btn-sm"
                                                    id={`PopoverCreateSV2Condition${search.id}`}
                                                    onClick={() => this.setState({ conditionCreateForId: search.id })}
                                                >
                                                    <i className="fas fa-plus mr-1" /> Condicion
                                                </button>
                                            </div>
                                        </div>
                                        {(search.format_search_v2_conditions || []).length > 0 ? (
                                            <div style={{ fontSize: 13 }}>
                                                {search.format_search_v2_conditions.map((cond, idx) => (
                                                    <div key={cond.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', borderBottom: '1px solid #f0f0f0' }}>
                                                        {idx > 0 && (
                                                            <span style={{ fontSize: 11, fontWeight: 600, color: cond.conditional === 'O' ? '#e67e22' : '#3498db', minWidth: 24 }}>
                                                                {cond.conditional === 'O' ? 'O' : 'Y'}
                                                            </span>
                                                        )}
                                                        {idx === 0 && <span style={{ minWidth: 24 }} />}
                                                        <span style={{ fontWeight: 500 }}>{cond.question_info.name}</span>
                                                        <span style={{ color: '#999', fontSize: 11 }}>{cond.operation}</span>
                                                        {cond.compare_mode && cond.compare_mode !== 'value' && cond.question_to_compare_info ? (
                                                            <span style={{ color: '#8e44ad', fontWeight: 500 }}>
                                                                [{cond.question_to_compare_info.name}]
                                                            </span>
                                                        ) : (
                                                            <span style={{ color: '#27ae60', fontWeight: 500 }}>"{cond.value && cond.value.includes(',') ? cond.value.split(',').join(' y ') : cond.value}"</span>
                                                        )}
                                                        <div style={{ marginLeft: 'auto', display: 'flex', gap: 4 }}>
                                                            {this.state.conditionEditId === cond.id && (
                                                                <FormCreateCondition
                                                                    isOpen={true}
                                                                    target={`PopoverEditSV2Condition${cond.id}`}
                                                                    format_search_v2={search}
                                                                    modeEdit={true}
                                                                    condition={cond}
                                                                    onUpdated={(register) => this.handleConditionUpdated(search.id, register)}
                                                                    onClose={() => this.setState({ conditionEditId: "" })}
                                                                />
                                                            )}
                                                            <button className="btn btn-sm p-0" id={`PopoverEditSV2Condition${cond.id}`} onClick={() => this.setState({ conditionEditId: cond.id })}>
                                                                <i className="fas fa-pencil-alt" style={{ ...styeleIcons, fontSize: 12 }} />
                                                            </button>
                                                            <button className="btn btn-sm p-0" onClick={() => this.deleteCondition(search.id, cond.id)}>
                                                                <i className="fas fa-trash-alt" style={{ ...styeleIcons, fontSize: 12 }} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div style={{ textAlign: 'center', padding: '8px 0', color: '#999', fontSize: 12 }}>
                                                Sin condiciones — se buscara por la pregunta disparadora unicamente
                                            </div>
                                        )}
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    ))
                ) : (
                    <div className="card">
                        <div className="card-body text-center">
                            <h4>No hay buscadores configurados</h4>
                            <p style={{ color: '#999', fontSize: 13 }}>Haz clic en "Nuevo buscador" para crear uno.</p>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Index;
